import Vue from 'vue'
import Vuex from 'vuex'
// import info from './modules/detailInfo'
// import strategy from './modules/strategy'
import history from './modules/searchHistory'
// import searchText from './modules/searchText'
// import nopointModule from './modules/nopointModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    // info,
    // strategy,
    history,
    // nopointModule,
    // searchText
  },
  // eslint-disable-next-line no-undef
  strict: process.env.NODE_ENV !== 'production'
})

export default store
